import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { CreditCard, Receipt } from "lucide-react";
import Payments from "./Payments";
import ShopSales from "./ShopSales";
import { FeatureOff } from "./Features";

const VIEWS = [["services", "payments", "Service sales", CreditCard, <Payments />, "payments"], ["shop", "shop-sales", "Shop sales", Receipt, <ShopSales />, "shop"]];

export default function Revenue({ tabs, features, isOwner }) {
  const views = VIEWS.filter(([, tab]) => tabs.includes(tab));
  const off = (k) => features?.[k] === false;
  return (
    <div data-testid="admin-revenue">
      <div className="rev-switch" role="tablist" data-testid="revenue-switch">
        {views.map(([path, , label, Icon, , k]) => (
          <NavLink key={path} to={`/admin/revenue/${path}`} className={`rev-btn ${off(k) ? "is-off" : ""}`} data-testid={`revenue-tab-${path}`}><Icon size={15} /> {label}{off(k) && " · Off"}</NavLink>
        ))}
      </div>
      <Routes>
        {views.map(([path, , , , el, k]) => <Route key={path} path={path} element={off(k) ? <FeatureOff k={k} isOwner={isOwner} /> : el} />)}
        <Route path="*" element={<Navigate to={`/admin/revenue/${views[0][0]}`} replace />} />
      </Routes>
    </div>
  );
}
